import { ApiTablePage } from 'components/ApiTablePage/ApiTablePage';
import { createFrontendOnlyColumn } from 'components/Table/columns/frontendOnlyColumn';
import { useLocale } from 'containers/App/LocaleContext';
import { DownloadSiteReport } from 'containers/DownloadSiteReport/DownloadSiteReport';
import { memo } from 'react';
import type { FC } from 'react';
import { useTableEndpoint } from 'utils/table/useTableEndpoint';

export const siteLowLevelDesignApiEndpoint = '/tables/inventory/sites';

const BareSiteLowLevelDesignPage: FC = () => {
  const siteLowLevelDesignMsg = useLocale().siteLowLevelDesign;

  const endpoint = useTableEndpoint({
    apiEndpoint: siteLowLevelDesignApiEndpoint,
    alternative: {
      id: '/reports/site-low-level-design',
      title: siteLowLevelDesignMsg.pageTitle,
      webPath: '/reports/site-low-level-design',
      columns: [
        'siteName',
        'devicesCount',
        'usersCount',
        'stpDCount',
        'switchesCount',
        'vlanCount',
        'rDCount',
        'routersCount',
        'networksCount',
        createFrontendOnlyColumn({
          key: 'action',
          disabledSort: true,
          title: siteLowLevelDesignMsg.actionColumnTitle,
          webDependencies: ['siteName'],
          render: (row) => (
            <DownloadSiteReport
              buttonTitle={siteLowLevelDesignMsg.btnDownloadReport}
              siteName={row.siteName}
              variant='secondary'
              size='xxs'
            />
          ),
        }),
      ],
    },
  });

  return (
    <ApiTablePage
      tableClassName='m'
      endpoint={endpoint}
      additionalApiTableProps={{
        enableIntentEditor: true,
      }}
    />
  );
};

export const SiteLowLevelDesignPage = memo(BareSiteLowLevelDesignPage);
